module.exports = __webpack_public_path__ + "static/media/logoShopify.d66ca94d.png";